import { Routes } from '@angular/router';
import { loginGuard } from './guards/auth-login.guard';
import { authGuard } from './guards/auth.guard';


export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: 'login',
    canMatch: [loginGuard],
    title: 'Iniciar Sesión - GIF CARD',
    loadComponent: () =>
      import('./auth/feature/login/login.component').then((c) => c.LoginComponent),
  },
  {
    path: 'register',
    title: 'Registrarse - GIF CARD',
    loadComponent: () =>
      import('./auth/feature/register/register.component').then((c) => c.RegisterComponent),
  },
  {
    path: 'admin',
    canActivate: [authGuard],
    loadChildren: () => import('./admin/admin.routes').then((m) => m.adminRoutes),
  },
  {
    path: ':code',
    title: 'Tu mensaje - GIF CARD',
    loadComponent: () =>
      import('./view-qr/feature/view-qr.component').then((c) => c.ViewQrComponent),
  },
  { path: '**', redirectTo: 'login' },
];